// RichTextNoticias.js
import React from "react";

const combinedRegex =
  /(https?:\/\/[^\s]+)|(#(?:[a-zA-Z0-9_áéíóúÁÉÍÓÚñÑ_]+))/gu;

const isImageUrl = (url) => {
  if (!url) return false;
  const clean = url.split("?")[0].toLowerCase();
  return /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(clean);
};

const RichTextNoticias = ({
  text,
  showImages = true,
  hideImageUrls = true, // ⚠️ por defecto NO mostramos el texto de las URLs de imagen
}) => {
  if (!text) return null;

  try {
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = combinedRegex.exec(text)) !== null) {
      const [fullMatch, urlMatch, hashtagMatch] = match;
      const index = match.index;

      // Texto antes del match
      if (index > lastIndex) {
        parts.push(
          <span key={`text-${index}`}>
            {text.slice(lastIndex, index)}
          </span>
        );
      }

      // Caso URL
      if (urlMatch) {
        const url = urlMatch;
        const isImg = isImageUrl(url);

        // 1) Link clicable SOLO si:
        //    - NO es imagen, o
        //    - ES imagen pero hideImageUrls === false
        if (!isImg || !hideImageUrls) {
          parts.push(
            <a
              key={`link-${index}`}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="noticia-link"
            >
              {url}
            </a>
          );
        }

        // 2) Si es imagen, renderizamos <img> SOLO si showImages === true
        if (isImg && showImages) {
          parts.push(
            <div
              key={`img-${index}`}
              className="my-2"
            >
              <img
                src={url}
                alt="Imagen de la noticia"
                className="img-fluid rounded noticia-img-embed"
                loading="lazy"
                onError={(e) => {
                  // Si la imagen falla, la escondemos para no romper el layout
                  e.target.style.display = "none";
                }}
              />
            </div>
          );
        }
      }

      // Caso hashtag
      if (hashtagMatch) {
        const tag = hashtagMatch.slice(1); // sin '#'
        parts.push(
          <span
            key={`tag-${index}`}
            className="noticia-hashtag badge rounded-pill bg-light text-primary border me-1"
            title={`Etiqueta: #${tag}`}
          >
            #{tag}
          </span>
        );
      }

      lastIndex = index + fullMatch.length;
    }

    // Texto restante
    if (lastIndex < text.length) {
      parts.push(
        <span key={`text-final`}>
          {text.slice(lastIndex)}
        </span>
      );
    }

    return <>{parts}</>;
  } catch (err) {
    console.error("[RichTextNoticias] Error parseando texto:", err);
    // Fallback seguro: texto plano
    return <span>{text}</span>;
  }
};

export default RichTextNoticias;
